export { HeroImage } from './HeroImage';
